<div class="inputGrid w-full">
    <app-input-fulltext
        [form]="form"
        [options]="store.serviceRecords()"
        (selectedOptionChange)="selectedServiceRecordChange($event)"
    ></app-input-fulltext>
    <app-button
        [disabled]="!(isAllowed['folderRecord.create']() || isAllowed['work.create']()) || (folderStore.isTerminated())"
        (clickEvent)="save()"
        icon="pi-save"
        label="database.persons.saveButton"
        class="white-space-nowrap"
    ></app-button>
    <app-button
        icon="pi-print"
        severity="secondary"
        label="folder.carePlan.action.print"
        class="white-space-nowrap"
        (clickEvent)="print()"
    ></app-button>
    <div class="flex-column gap left-container">
        @if (store.folder() && store.serviceId()) {
            <app-service-pattern-wysiwyg
                placeholder="database.persons.serviceRecord.text"
                [form]="form"
                editorKey="FolderServiceRecordsData"
                id="selectedServiceRecordData"
                [height]="undefined"
                [personId]="store.folder()!.person.id"
                [serviceId]="store.serviceId()"
                [usage]="ServicePatternStructureUsageEnum.SERVICE_RECORD"
                (addedPattern)="formAddText(form, 'selectedServiceRecordData', $event.content)"
                [patternGroups]="wysiwygPatterGroupsMedicalFolder"
            ></app-service-pattern-wysiwyg>
        }
    </div>

    <p-listbox class="fr-2"
        [options]="store.serviceRecords()"
        [(ngModel)]="selectedServiceRecord"
        (onChange)="listChange($event)"
        [filter]="true"
        [filterPlaceHolder]="'database.persons.history' | translate"
        emptyMessage="{{'database.persons.noResultsFound' | translate}}"
        optionLabel="key"
        dataKey="index"
        styleClass="h-full"
        scrollHeight="calc(100vh - 20rem)"
    >
        <ng-template let-serviceRecord pTemplate="item">
            <div (contextmenu)="rightClick(contextMenu, $event, serviceRecord)">
                <div class="flex-column gap-x-small">
                    <div>{{ serviceRecord.createdAt }}</div>
                    @if (serviceRecord.users && serviceRecord.users.length > 0) {
                        <app-user-chip [user]="serviceRecord.users[0]"></app-user-chip>
                    }
                </div>
            </div>
        </ng-template>
    </p-listbox>
</div>

<p-contextMenu #contextMenu [model]="contextMenuItems"></p-contextMenu>
